import React from 'react'
import { BadgeStyles } from './Styled'

const CustomBadge = (props) => {
    const { value } = props

    return (
        <BadgeStyles badgeContent={value} color="primary"/>
    )
}

export default CustomBadge